import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function luckyDrawModel() {
    const createCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/Create",
        method: "POST",
        xRequest: "",
        payload: {
            Name_TH: "",
            Name_EN: "",
            Main_Image: null,
            Sub_Image: null,
            Point: null,
            Quantity: null,
            Conditions_TH: "",
            Conditions_EN: "",
            Valid_Form: null,
            Valid_Through: null,
            IsLimit: null,
            Issue_Overall: "",
            Issue_Per_Month: "",
            Issue_Per_Day: "",
            Issue_Per_Customer: "",
            Issue_Per_Customer_Month: "",
            Issue_Per_Customer_Day: "",
            Status: null,
        },
    });

    const fetchCampaignList = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/List",
        method: "POST",
        xRequest: "",
        payload: {
            Page: 1,
            Limit: 10,
            Filters: [],
            Ordering: []
        },
    });

    const fetchCampaignDetail = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/Detail",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null
        },
    });

    const editCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/Update",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            Name_TH: "",
            Name_EN: "",
            Main_Image: null,
            Sub_Image: null,
            Main_Image_URL: null,
            Sub_Image_URL: null,
            Point: null,
            Quantity: null,
            Conditions_TH: "",
            Conditions_EN: "",
            Valid_Form: null,
            Valid_Through: null,
            IsLimit: null,
            Issue_Overall: "",
            Issue_Per_Month: "",
            Issue_Per_Day: "",
            Issue_Per_Customer: "",
            Issue_Per_Customer_Month: "",
            Issue_Per_Customer_Day: "",
            Status: null,
        },
    });

    const deleteCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/Delete",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,

        },
    });

    const setCampaignStatus = reactive({
        api: apiEndpoint.bcrm_platform + "/LuckyDraw/Change_Status_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            Status: null
        },
    });

    return {
        createCampaign,
        fetchCampaignList,
        fetchCampaignDetail,
        editCampaign,
        deleteCampaign,
        setCampaignStatus,
    };
}